<template>
  <div class="page-wrapper" >
    <search-list  @findData="findData"></search-list>
    <table-list class="mt20" :columns="columns" :data="dataList" :loading="loading" :total="total" :current="current" @change-page="changePage"></table-list>
    <zo-list :n="zolistN" :projectFid="zolistProjectFid" :projectName="zolistprojectName"></zo-list>
    <status-modal :n="statusN" :pageData="statusData" @operatedone="getPageList"></status-modal>
    <head-img :n="headimgN" :fid="fid"></head-img>
    <img-config :n="imgConfigN" :fid="fid" :projectFid="projectFid"></img-config>
    <label-config :n="labelConfigN" :fid="fid" :projectFid="projectFid"></label-config>
    <activity-config :n="activityConfigN" :fid="fid" :projectFid="projectFid"></activity-config>
    <house-config :n="houseConfigN" :fid="fid" :projectFid="projectFid"></house-config>
    <special-config :n="specialConfigN" :fid="fid" :projectFid="projectFid"></special-config>
    <public-config :projectFid="projectFid" :n="publicConfigN"></public-config>
    <IconModal :n="iconN" :fid="fid"></IconModal>
    <share-modal :n="shareN" :fid="fid"></share-modal>
    <status-modal2 :n="statusN2" :pageData="statusData" @operatedone="getPageList"></status-modal2>
    <supporting-modal :n="supportingN" :fid="fid" :projectFid="projectFid"></supporting-modal>
    <bizcircle-tag :n="bizcircleN" :fid="fid" :projectFid="projectFid"></bizcircle-tag>
    <sug-word :n="keySugN" :fid="fid" :projectFid="projectFid"></sug-word>
  </div>
</template>

<script>
  import SearchList from './components/SearchList'
  import TableList from "components/TableList/index";
  import {projectConfigList} from "../../../api/projectConfig";
  import ZoList from './components/ZoList'
  import {validConfig} from "../../../api/projectConfig";
  import StatusModal from './components/StatusModal'
  import {deepClone} from "../../../utils/format";
  import HeadImg from './components/HeadImg'
  import ImgConfig from './components/ImgConfig'
  import BizcircleTag from './components/BizcircleTag'
  import LabelConfig from './components/LabelConfig'
  import ActivityConfig from './components/ActivityConfig'
  import HouseConfig from './components/HouseConfig'
  import SpecialConfig from './components/SpecialConfig'
  import PublicConfig from './components/PublicConfig'
  import IconModal from './components/IconModal'
  import ShareModal from './components/ShareModal'
  import StatusModal2 from './components/StatusModal2'
  import SupportingModal from './components/SupportingModal'
  import SugWord from './components/SugWord'
  import ActivityList from "../houseTypeConfig/components/ActivityList";
  import {saveProjectConfigInfo} from "../../../api/projectConfig";

  export default {
    name: "projectConfig",
    components: {
      ActivityList,
      StatusModal2,
      ImgConfig,
      LabelConfig,
      ActivityConfig,
      HouseConfig,
      SpecialConfig,
      SearchList,
      TableList,
      ZoList,
      StatusModal,
      HeadImg,
      PublicConfig,
      IconModal,
      ShareModal,
      SupportingModal,
      BizcircleTag,
      SugWord,
    },
    data() {
      return {
        statusN2: 0,
        fid: '',
        shareN: 0,
        iconN: 0,
        publicConfigN: 0,
        projectFid: '',
        imgConfigN: 0,
        labelConfigN: 0,
        activityConfigN: 0,
        houseConfigN: 0,
        specialConfigN: 0,
        headimgN: 0,
        supportingN:0,
        keySugN:0,
        statusData: {},
        statusN: 0,
        bizcircleN:0,
        zolistprojectName: '',
        zolistProjectFid: '',
        zolistN: 0,
        searchData: {
          page: 1,
          limit: 10,
          projectName: '',
          status: ''
        },
        current: 1,
        total: 0,
        dataList:[],
        loading:false,
        columns:[
          {
            title: "项目名称",
            key: "projectName",
            width: 150,
            align: "center",
            fixed:"left"
          },
          {
            title: "操作",
            key: "keyA",
            width: 100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'projectConfig/updateConfigStutas'
                    }
                  }
                ],
                on:{
                  click:()=>{
                    this.updateStatus(params.row)
                  }
                }
              },params.row['status']===1?'网站隐藏':'网站显示')

            }
          },
          {
            title: "项目状态",
            key: "projectStateName",
            width: 100,
            align: "center",
            render: (h, params) => {
              return h('a', {
                on: {
                  click: () => {
                    this.statusData = params.row
                    this.statusN2++
                  }
                }
              }, params.row['projectStateName'])
            }
          },
          {
            title: "项目头图",
            key: "keyB",
            width: 100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.fid=params.row['fid']
                    this.headimgN++
                  }
                }
              },'配置')
            }
          },
          {
            title: "图片配置",
            key: "keyC",
            width: 100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.fid=params.row['fid']
                    this.projectFid=params.row['projectFid']
                    this.imgConfigN++
                  }
                }


              },'配置')
            }
          },
          {
            title: "特色标签",
            key: "keyD",
            width: 100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.fid=params.row['fid']
                    this.projectFid=params.row['projectFid']
                    this.labelConfigN++
                  }
                }


              },'配置')
            }
          },
          {
            title: "活动运营",
            key: "keyE",
            width: 100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.fid=params.row['fid']
                    this.projectFid=params.row['projectFid']
                    this.activityConfigN++
                  }
                }


              },'配置')
            }
          },
          {
            title: "看房配置",
            key: "keyF",
            width: 100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.fid=params.row['fid']
                    this.projectFid=params.row['projectFid']
                    this.houseConfigN++
                  }
                }


              },'配置')
            }
          },
          {
            title: "特色图文",
            key: "keyG",
            width: 100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.fid=params.row['fid']
                    this.projectFid=params.row['projectFid']
                    this.specialConfigN++
                  }
                }


              },'配置')
            }
          },
          {
            title: "周边配套",
            key: "surroundingSupporting",
            align: "center",
            width: 100,
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.projectFid = params.row['projectFid']
                    this.fid=params.row['fid']
                    this.supportingN++
                  }
                }
              },'配置')
            }

          },
          {
            title: "ZO专属",
            key: "keyD",
            width: 100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.zolistProjectFid=params.row['projectFid']
                    this.zolistprojectName=params.row['projectName']
                    this.zolistN++
                  }
                }
              },'配置')
            }
          },
          {
            title: "公区配套设施",
            key: "keyE",
            width: 100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.projectFid=params.row['projectFid']
                    this.publicConfigN++
                  }
                }

              },'配置')
            }
          },
          {
            title: "项目Icon",
            key: "keyF",
            width: 100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.fid=params.row['fid']
                    this.iconN++
                  }
                }


              },'配置')
            }
          },
          {
            title: "分享链接",
            key: "keyH",
            width: 100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.fid=params.row['fid']
                    this.shareN++
                  }
                }
              },'链接')
            }
          },
          {
            title: "空气质量报告",
            key: "keyI",
            width: 100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'projectConfig/saveProjectConfigInfo'
                    }
                  }
                ],
                on:{
                  click:()=>{
                    this.updateShowAirReport(params.row)
                  }
                }
              },params.row['showAirReport']===1?'不展示':'展示')

            }
          },
          {
            title: "商圈配置",
            //key: "keyC2",
            width:100,
            align: "center",
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.fid=params.row['fid']
                    this.projectFid=params.row['projectFid']
                    this.bizcircleN++
                  }
                }
              },'配置')
            }
          },
          {
            title: "sug联想词",
            key: "keySug",
            align: "center",
            width: 100,
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    this.projectFid = params.row['projectFid']
                    this.fid=params.row['fid']
                    this.keySugN++
                  }
                }
              },'配置')
            }

          },
        ],
      }
    },
    methods:{
      updateStatus(item){
        if(item.status===1){
          this.statusData=item
          this.statusN++
        }
        else {
          var params={
            fid:item.fid
          }
          validConfig(params).then(res=>{
            this.statusData=item
            this.statusN++
          }).catch(error=>{
          })
        }

      },
      updateShowAirReport(item){
        var params={
          projectFid:item.projectFid,
          showAirReport:item.showAirReport==1?0:1
        }
        saveProjectConfigInfo(params).then(res=>{
          this.getPageList()
        }).catch(error=>{
        })
      },
      findData(value){
        this.current=1
        this.searchData=Object.assign(value)
        this.getPageList()
      },
      getPageList(){
        projectConfigList(this.searchData).then(res=>{
          this.dataList=res.data.projectConfigList
          this.total=res.data.total
        }).catch(res=>{
        })
      },
      changePage(n){
        this.searchData.page=n
        this.current=n
        this.getPageList()
      }
    },
    created(){
      this.getPageList()
    }
  }
</script>

<style scoped>

</style>
